<template>
  <mdb-container
    fluid
    v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }"
  >
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold">
      <strong>Ajustes</strong>
    </h2>
    <div
      class="mt-lg-2 mb-1 pb-1"
      style="font-family: OpenSans-Regular; font-size: 12px; color: #1d71b8"
    >
      Configura las aplicaciones de residentes y vigilantes
    </div>

    <!--Section: Analytical panel-->
    <section class="mb-5 mt-4">
      <mdb-container>
        <mdb-row>
          <mdb-col col="6">
            <mdb-card-group deck>
              <mdb-card class="Rectngulo-1405" cascade>
                <div
                  class="price white-text rounded-top"
                  v-bind:style="{
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    textAlign: 'center',
                    background: '#67a3cf',
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    lineHeight: '1.38',
                  }"
                >
                  <mdb-icon far icon="envelope-open" />&nbsp; Mensaje de
                  invitación
                </div>
                <mdb-card-body>
                  <mdb-col>
                    <mdb-row>
                      <div class="form-group">
                        <label for="labelText" style="color: #a09c9c"
                          >El siguiente mensaje se mostrará al compartir una
                          invitación:</label
                        >
                        <textarea
                          class="form-control txt-area-st"
                          id="labelText"
                          rows="4"
                          maxlength="80"
                          required
                          v-model="invitationMessage"
                          :disabled="disableEdition"
                        ></textarea>
                        <span
                          style="
                            color: #a09c9c;
                            margin-top: 4rem;
                            position: absolute;
                          "
                          class="limiter"
                          >{{ characterRemaining }}/80</span
                        >
                      </div>
                    </mdb-row>
                    <mdb-card-footer>
                      <mdb-btn
                        v-show="!isLoading"
                        style="bottom: -4rem"
                        class="btn btn-style-save"
                        @click="configureAppVig()"
                        >Guardar</mdb-btn
                      >
                      <mdb-btn
                        v-show="isLoading"
                        style="bottom: -4rem"
                        class="btn btn-style-save"
                        disabled
                      ></mdb-btn>
                      <mdb-btn
                        style="bottom: -4rem"
                        class="btn btn-style-edit"
                        @click="disableEdition = !disableEdition"
                        >Editar</mdb-btn
                      >
                    </mdb-card-footer>
                  </mdb-col>
                </mdb-card-body>
              </mdb-card>
            </mdb-card-group>
          </mdb-col>
          <mdb-col col="6">
            <mdb-card-group deck>
              <mdb-card class="Rectngulo-1405" cascade>
                <div
                  class="price white-text rounded-top"
                  v-bind:style="{
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    textAlign: 'center',
                    background: '#67a3cf',
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    lineHeight: '1.38',
                  }"
                >
                  <mdb-icon far icon="clock" />&nbsp;Validez del código de
                  invitación
                </div>
                <mdb-card-body>
                  <mdb-col>
                    <mdb-row>
                      <div class="form-group">
                        <span style="color: #a09c9c">
                          Puede editar el siguiente periodo de validez del
                          <span style="font-family: OpenSans-bold"
                            >código de invitación</span
                          >
                          a su conveniencia:
                        </span>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="card-body-st" @click="modal1 = true">
                        {{ invitationTime }}
                        <span style="font-size: 30px">horas</span>
                      </div>
                    </mdb-row>
                  </mdb-col>
                  <mdb-card-footer>
                    <mdb-btn
                      v-show="!isLoading"
                      style="bottom: -6rem"
                      class="btn btn-style-save"
                      @click="configureAppVig()"
                      >Guardar</mdb-btn
                    >
                    <mdb-btn
                      v-show="isLoading"
                      style="bottom: -6rem"
                      class="btn btn-style-save"
                      disabled
                    ></mdb-btn>
                  </mdb-card-footer>
                </mdb-card-body>
              </mdb-card>
            </mdb-card-group>
          </mdb-col>
          <mdb-col col="6">
            <mdb-card-group deck>
              <mdb-card class="Rectngulo-1405" cascade>
                <div
                  class="price white-text rounded-top"
                  v-bind:style="{
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    textAlign: 'center',
                    background: '#67a3cf',
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    lineHeight: '1.38',
                  }"
                >
                  <mdb-icon far icon="calendar-alt" />&nbsp;Validez de visita
                  frecuente
                </div>
                <mdb-card-body>
                  <mdb-col>
                    <mdb-row>
                      <div class="form-group">
                        <span style="color: #a09c9c">
                          Puede editar el siguiente periodo de validez del
                          <span style="font-family: OpenSans-bold"
                            >código de un invitado frecuente</span
                          >
                          a su conveniencia:
                        </span>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="card-body-st" @click="modal2 = true">
                        {{ frequentTime }}
                        <span style="font-size: 30px">{{
                          frequentTimeValues
                        }}</span>
                      </div>
                    </mdb-row>
                  </mdb-col>
                  <mdb-card-footer>
                    <mdb-btn
                      v-show="!isLoading"
                      style="bottom: -6rem"
                      class="btn btn-style-save"
                      @click="configureAppVig()"
                      >Guardar</mdb-btn
                    >
                    <mdb-btn
                      v-show="isLoading"
                      style="bottom: -6rem"
                      class="btn btn-style-save"
                      disabled
                    ></mdb-btn>
                  </mdb-card-footer>
                </mdb-card-body>
              </mdb-card>
            </mdb-card-group>
          </mdb-col>
          <mdb-col col="6">
            <mdb-card-group deck>
              <mdb-card class="Rectngulo-1405" cascade>
                <div
                  class="price white-text rounded-top"
                  v-bind:style="{
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    textAlign: 'center',
                    background: '#67a3cf',
                    fontFamily: 'OpenSans-Regular',
                    fontSize: '12px',
                    lineHeight: '1.38',
                  }"
                >
                  <mdb-icon icon="custom-icon-ajustes" />Configuración App
                  Vigilantes
                </div>
                <mdb-card-body>
                  <mdb-col style="margin-bottom: -3rem">
                    <mdb-row>
                      <div class="form-group">
                        <span style="color: #a09c9c"
                          >Elije los datos que el vigilante puede ver en la app
                          sobre los residentes</span
                        >
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="form-group" style="color: #a09c9c">
                        <span>El vigilante puede buscar por:</span>
                        <mdb-form-inline style="font-size: 11px">
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="defaultUnchecked"
                              v-model="checkName1"
                            />
                            <label
                              class="form-check-label"
                              for="defaultUnchecked"
                              >Nombre</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option2"
                              v-model="checkAdd"
                            />
                            <label class="form-check-label" for="option2"
                              >Dirección</label
                            >
                          </div>
                          <div
                            v-if="whoami.frac == 'Club Tres Marias'"
                            class="custom-control custom-checkbox"
                          >
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option3"
                              v-model="checkAccion"
                            />
                            <label class="form-check-label" for="option3"
                              >No. acción</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option4"
                              v-model="checkA"
                              @click="select_all"
                            />
                            <label class="form-check-label" for="option4"
                              >Todo</label
                            >
                          </div>
                        </mdb-form-inline>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div class="form-group" style="color: #a09c9c">
                        <span>El vigilante puede visualizar:</span>
                        <mdb-form-inline style="font-size: 11px">
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option4-1"
                              v-model="checkName1"
                              disabled
                            />
                            <label class="form-check-label" for="option4-1"
                              >Nombre completo</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="phone"
                              v-model="checkPhone"
                            />
                            <label class="form-check-label" for="phone"
                              >Teléfono</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option4-3"
                              v-model="checkPlace"
                              disabled
                            />
                            <label class="form-check-label" for="option4-3"
                              >Domicilio</label
                            >
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              class="form-control form-check-input"
                              id="option4-4"
                              v-model="checkCommonArea"
                              disabled
                            />
                            <label class="form-check-label" for="option4-4"
                              >Área común</label
                            >
                          </div>
                        </mdb-form-inline>
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <div
                        class="custom-control custom-checkbox"
                        style="z-index: 1"
                      >
                        <input
                          type="checkbox"
                          class="form-control form-check-input"
                          id="check1"
                          v-model="check1"
                        />
                        <label
                          class="form-check-label"
                          for="check1"
                          style="color: #a09c9c"
                          >Uso de folio (cono o marbete) para registro de
                          invitado *Obligatorio</label
                        >
                      </div>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col
                        md="12"
                        class="form-group mt-1"
                        style="color: #a09c9c"
                      >
                        <span>Activar buscador de visitas sugeridas:</span>
                      </mdb-col>
                      <mdb-col
                        md="6"
                        class="custom-control custom-checkbox"
                        style="z-index: 1"
                      >
                        <input
                          type="checkbox"
                          class="form-control form-check-input"
                          id="checkVisitor"
                          v-model="checkVisitorSearch"
                        />
                        <label
                          class="form-check-label"
                          for="checkVisitor"
                          style="color: #a09c9c"
                        ></label>
                      </mdb-col>
                      <mdb-col md="6" class="d-flex justify-content-end">
                        <mdb-btn
                          v-show="!isLoading"
                          class="btn btn-style-save"
                          @click="configureAppVig()"
                          >Guardar</mdb-btn
                        >
                        <mdb-btn
                          v-show="isLoading"
                          class="btn btn-style-save"
                          disabled
                        >
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </mdb-btn>
                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-card-body>
              </mdb-card>
            </mdb-card-group>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>

    <mdb-modal :show="modal1" @close="modal1 = false">
      <mdb-modal-header
        class="text-center Rectngulo-1570"
        style="background-color: "
      >
        <mdb-modal-title
          tag="span"
          class
          style="color: #ffffff; margin-left: 25%"
        >
          <span style="font-size: 22px; font-family: OpenSans-Semibold"
            >Horario</span
          >
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <ul class="list-group">
          <li class="list-group-item">
            <a
              @click="
                modal1 = false;
                invitationTime = 24;
              "
              >24 horas</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal1 = false;
                invitationTime = 12;
              "
              >12 horas</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal1 = false;
                invitationTime = 8;
              "
              >8 horas</a
            >
          </li>
        </ul>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="modal2" @close="modal2 = false">
      <mdb-modal-header
        class="text-center Rectngulo-1570"
        style="background-color: "
      >
        <mdb-modal-title
          tag="span"
          class
          style="color: #ffffff; margin-left: 15%"
        >
          <span style="font-size: 22px; font-family: OpenSans-Semibold"
            >Duración</span
          >
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <ul class="list-group">
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 1;
                frequentTimeValues = 'Semana';
              "
              >1 Semana</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 2;
                frequentTimeValues = 'Semanas';
              "
              >2 Semanas</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 1;
                frequentTimeValues = 'Mes';
              "
              >1 Mes</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 3;
                frequentTimeValues = 'Meses';
              "
              >3 Meses</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 6;
                frequentTimeValues = 'Meses';
              "
              >6 Meses</a
            >
          </li>
          <li class="list-group-item">
            <a
              @click="
                modal2 = false;
                frequentTime = 1;
                frequentTimeValues = 'Año';
              "
              >1 Año</a
            >
          </li>
        </ul>
      </mdb-modal-body>
    </mdb-modal>
    <!-- /.Section: data tables -->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Swal from "sweetalert2";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbFormInline,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbListGroup,
  mdbListGroupItem,
} from "mdbvue";

export default {
  name: "Ajustes",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbFormInline,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbListGroup,
    mdbListGroupItem,
  },
  data() {
    return {
      disableEdition: true,
      isLoading: false,
      checkName1: true,
      checkAdd: true,
      checkCommonArea: true,
      checkAccion: true,
      checkName2: true,
      checkPhone: false,
      checkPlace: true,
      checkA: true,
      disabledName1: true,
      disabledAdd: true,
      disabledN: true,
      disabledAccion: true,
      invitationTime: 12,
      frequentTime: 1,
      frequentTimeValues: "Semana",
      modal1: false,
      modal2: false,
      check1: false,
      checkVisitorSearch: false,
      invitationMessage:
        "Hola, tienes una invitación. Genera tu código de acceso, haz clic.",
      whoami: [],
    };
  },
  methods: {
    select_all() {
      this.checkA = !this.checkA;
      if (this.checkA) {
        this.checkName1 = true;
        this.checkAdd = true;

        this.checkAccion = true;
        this.disabledName1 = true;
        this.disabledAdd = true;
        this.disabledN = true;
        this.disabledAccion = true;

        this.checkPlace = true;
        this.checkCommonArea = true;
      } else {
        this.checkName1 = false;
        this.checkAdd = false;

        this.checkAccion = false;
        this.disabledName1 = false;
        this.disabledAdd = false;
        this.disabledN = false;
        this.disabledAccion = false;

        this.checkPlace = false;
        this.checkCommonArea = false;
      }
    },
    checkSession() {
      let aux = this;
      Axios.get(Servers.serverApi + "/api/users/me", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
      }).then(
        function (response) {
          const data = response.data;
          aux.whoami = data;
          aux.check1 = data.testFrac.folioRequired;
          aux.checkVisitorSearch = data.testFrac.visitorSearch;
          aux.checkName1 = data.testFrac.searchName;
          aux.checkAdd = data.testFrac.searchAddress;
          if (data.frac == "Club Tres Marias")
            aux.checkAccion = data.testFrac.searchAction;
          else aux.checkAccion = true;
          aux.checkName2 = data.testFrac.viewResidentName;
          aux.checkPlace = data.testFrac.viewVisitAddress;
          aux.checkPhone = data.testFrac.viewResidentNumber;
          aux.checkCommonArea = data.testFrac.viewVisitAddress;
          aux.invitationTime = data.testFrac.invitationValidity;
          aux.frequentTime = data.testFrac.frequentInvitationValidity;

          if (data.testFrac.invitationMessage != null) {
            aux.invitationMessage = data.testFrac.invitationMessage;
          }

          switch (data.testFrac.frequentInvitationChronoUnit) {
            case "MONTHS":
              aux.frequentTime == 1
                ? (aux.frequentTimeValues = "Mes")
                : (aux.frequentTimeValues = "Meses");
              break;
            case "WEEKS":
              aux.frequentTime == 1
                ? (aux.frequentTimeValues = "Semana")
                : (aux.frequentTimeValues = "Semanas");
              break;
            case "YEARS":
              aux.frequentTimeValues = "Año";
              break;
            default:
              break;
          }

          if (data.frac == "Club Tres Marias") {
            if (
              data.testFrac.searchName &&
              data.testFrac.searchAddress &&
              data.testFrac.searchAction
            )
              aux.checkA = true;
            else aux.checkA = false;
          } else {
            if (data.testFrac.searchName && data.testFrac.searchAddress)
              aux.checkA = true;
            else aux.checkA = false;
          }
        },
        function (error) {
          console.log(error.response.data);
        }
      );
    },

    configureAppVig() {
      if (this.invitationMessage.length == 0) {
        Swal.fire({
          title:
            "<span style='font-size: 20px'>Errorr en el mensaje de invitación</span>",
          html: "<span style='font-size: 12px'>El mensaje no puede ser vacío, por favor establece un mensaje para tus invitaciones</span>",
          type: "warning",

          confirmButtonText: "Aceptar",
          customClass: {
            confirmButton: "btn-modal-accept",
          },
          onClose: () => {
            return;
          },
        });
      } else {
        var tempString = "YEARS";

        if (
          this.frequentTimeValues === "Semana" ||
          this.frequentTimeValues === "Semanas"
        ) {
          tempString = "WEEKS";
        }
        if (
          this.frequentTimeValues === "Mes" ||
          this.frequentTimeValues === "Meses"
        ) {
          tempString = "MONTHS";
        }

        var data = {
          folioRequired: this.check1,
          visitorSearch: this.checkVisitorSearch,
          searchName: this.checkName1,
          searchAddress: this.checkAdd,
          searchAction: this.checkAccion,
          viewResidentName: this.checkName1,
          viewVisitAddress: this.checkPlace,
          viewResidentAddress: this.checkCommonArea,
          viewResidentNumber: this.checkPhone,
          invitationValidity: this.invitationTime,
          invitationMessage: this.invitationMessage,
          frequentInvitationChronoUnit: tempString,
          frequentInvitationValidity: this.frequentTime,
        };
        let aux = this;

        Axios.put(
          Servers.serverApi +
            "/api/fracs/" +
            aux.whoami.testFrac.uuid +
            "/configure",
          data,
          {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          }
        )
          .then(function (response) {
            Swal.fire({
              title:
                "<span style='font-size: 20px;'>La configuración ha sido guardada</span>",
              html: "<span style='font-size: 12px;'></span>",
              type: "success",
              width: "30%",
              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept",
              },
              onClose: () => {
                aux.isLoading = false;
                window.location.reload();
              },
            });
          })
          .catch((error) => {
            console.log(error.response);
            Swal.fire({
              title:
                "<span style='font-size: 20px'>Ha ocurrido un error</span>",
              html: "<span style='font-size: 12px'>Por favor comuniquese con soporte</span>",
              imageUrl:
                Servers.serverImg + "apps/myfrac/admin/assets/Cancel_icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",

              confirmButtonText: "Aceptar",
              customClass: {
                confirmButton: "btn-modal-accept",
              },
              onClose: () => {
                aux.isLoading = false;
                window.location.reload();
              },
            });
          });
      }
    },
  },
  created() {},
  mounted() {
    this.checkSession();
  },
  watch: {
    checkAdd(newCheck) {
      if (newCheck) {
        this.checkPlace = true;
        this.checkCommonArea = true;
      } else {
        this.checkA = false;
        this.checkPlace = false;
        this.checkCommonArea = false;
      }
      if (newCheck && this.checkName1 && this.checkAccion) {
        this.checkA = true;
      }
    },
    checkName1(newCheck) {
      if (!newCheck) {
        this.checkA = false;
      }
      if (newCheck && this.checkAdd && this.checkAccion) {
        this.checkA = true;
      }
    },
    checkAccion(newCheck) {
      if (!newCheck) {
        this.checkA = false;
      }
      if (newCheck && this.checkAdd && this.checkName1) {
        this.checkA = true;
      }
    },
  },
  computed: {
    characterRemaining: function () {
      return this.invitationMessage.length;
    },
  },
};
</script>
<style>
.Rectngulo-1405 {
  width: 551.8px;
  height: 320px;
  box-shadow: 2px 5px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 1rem !important;
}
</style>

<style scoped>
.list-group-item {
  font-size: 19px !important;
}

ul li:hover {
  background: #4a90fb;
  color: #ffffff !important;
}

ul li a:hover {
  color: #ffffff !important;
}
</style>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style>
.btn-style-edit {
  width: 65px !important;
  height: 2rem !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  padding-top: 10px !important;
  border-radius: 7px !important;
  font-family: OpenSans-Regular !important;
  font-size: 8px !important;
  color: #ffffff !important;
  background-color: #1d71b8 !important;
  text-transform: capitalize !important;
}

.btn-style-save {
  width: 65px !important;
  height: 2rem !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  padding-top: 10px !important;
  border-radius: 7px !important;
  font-family: OpenSans-Regular !important;
  font-size: 8px !important;
  color: #ffffff !important;
  background-color: #23a7ed !important;
  text-transform: capitalize !important;
}

.Rectngulo-1405 {
  width: 551.8px;
  height: 320px;
  box-shadow: 2px 5px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-top: 1rem !important;
}

.card-footer {
  display: flex;
  position: relative;
  float: right;
  margin-left: auto;
  padding: 0 !important;
  background-color: white !important;
  border-top: 0 !important;
}

.Rectngulo-1570 {
  background-color: #3d87f8;
}

.modal-dialog .modal-content {
  width: auto;
  height: auto;
  margin-left: 8rem;
}

.fa-custom-icon-ajustes {
  width: 15px;
  height: 15px;
  background-image: url(https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Ajustes_icon.png) !important;
  background-size: 15px 15px !important;
  border: 0px !important;
}

.card-body-st {
  font-size: 40px;
  margin-left: 9rem;
  width: 50%;
  margin-top: 10%;
  margin-bottom: -40px;
}

.txt-area-st {
  width: 28rem !important;
  height: 10rem !important;
  margin-bottom: -4rem;
  z-index: 1;
  position: relative;
}
.btn-position {
  bottom: -4rem;
  position: relative;
}
</style>
